// extracted by mini-css-extract-plugin
export var header = "_g5-0";